export const MEMBERSHIP_BOX_DATA_KR = [
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_1.png',
      backgroundColor: '#CFE2FF',
      color: '#1E1E1E',
    },
    content: { title: '간편결제', desc: '등록된 카드 정보로 쉽고 빠른 결제' },
  },
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_2.png',
      backgroundColor: '#4095F9',
      color: '#FFFFFF',
    },
    content: { title: '회원 전용 혜택', desc: '충전 포인트 적립, 회원 할인, 쿠폰 프로모션 등 멤버십 전용 혜택 제공' },
  },
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_3.png',
      backgroundColor: '#16286A',
      color: '#FFFFFF',
    },
    content: {
      title: '편의 서비스',
      desc: '충전상태, 충전내역, 충전소 검색, 충전 금액 등 충전에 대한 모든 부분 조회 가능',
    },
  },
]
export const MEMBERSHIP_BOX_DATA_EN = [
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_1.png',
      backgroundColor: '#CFE2FF',
      color: '#1E1E1E',
    },
    content: { title: 'Easy Payment', desc: 'Quick and easy payment with registered card information' },
  },
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_2.png',
      backgroundColor: '#4095F9',
      color: '#FFFFFF',
    },
    content: {
      title: 'Member Exclusive Benefits',
      desc: 'Membership exclusive benefits such as earning charging points, member discounts, and coupon promotions',
    },
  },
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_3.png',
      backgroundColor: '#16286A',
      color: '#FFFFFF',
    },
    content: {
      title: 'Convenience Services',
      desc: 'View all aspects of charging such as charging status, charging history, charging station search, and charging amounts',
    },
  },
]
export const MEMBERSHIP_BOX_DATA_JP = [
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_1.png',
      backgroundColor: '#CFE2FF',
      color: '#1E1E1E',
    },
    content: { title: '簡単決済', desc: '登録されたカード情報で迅速かつ簡単に決済' },
  },
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_2.png',
      backgroundColor: '#4095F9',
      color: '#FFFFFF',
    },
    content: {
      title: '会員専用特典',
      desc: '充電ポイント積立、会員割引、クーポンプロモーションなどのメンバーシップ専用特典を提供',
    },
  },
  {
    decoration: {
      img_url: '/images/wev/service/wev_membership_item_3.png',
      backgroundColor: '#16286A',
      color: '#FFFFFF',
    },
    content: {
      title: '便利なサービス',
      desc: '充電状態、充電履歴、充電所検索、充電金額など、充電に関するすべての部分を確認可能',
    },
  },
]

export const MEMBERSHIP_APP_BOX_DATA_KR = [
  {
    img_url: '/images/wev/service/wev_membership_app_item_1.png',
    text: '실물 멤버십 카드',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_2.png',
    text: `모바일 멤버십 카드<br/>(APP 전용)`,
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_3.png',
    text: `NFC 인증<br/>(안드로이드만 가능)`,
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_4.png',
    text: 'QR 인증',
  },
]
export const MEMBERSHIP_APP_BOX_DATA_EN = [
  {
    img_url: '/images/wev/service/wev_membership_app_item_1.png',
    text: 'Physical Membership Card',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_2.png',
    text: 'Mobile Membership Card<br/>(APP Only)',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_3.png',
    text: 'NFC Authentication<br/>(Android Only)',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_4.png',
    text: 'QR Authentication',
  },
]
export const MEMBERSHIP_APP_BOX_DATA_JP = [
  {
    img_url: '/images/wev/service/wev_membership_app_item_1.png',
    text: '実物メンバーシップカード',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_2.png',
    text: 'モバイルメンバーシップカード<br/>(アプリ専用)',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_3.png',
    text: 'NFC認証<br/>(アンドロイドのみ対応)',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_4.png',
    text: 'QR認証',
  },
]

export const APP_SECTION_02_DATA_KR = [
  {
    img_url: '/images/wev/service/wev_membership_app_item_1.png',
    text: '실물 멤버십 카드',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_2.png',
    text: `모바일 멤버십 카드\n(APP 전용)`,
  },
  {
    img_url: '/images/wev/service/wev_app_item_3.png',
    text: `NFC, QR 인증`,
  },
  {
    img_url: '/images/wev/service/wev_app_item_4.png',
    text: '멤버십 로밍 기업',
  },
]
export const APP_SECTION_02_DATA_JP = [
  {
    img_url: '/images/wev/service/wev_membership_app_item_1.png',
    text: '実物メンバーシップカード',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_2.png',
    text: 'モバイルメンバーシップカード\n(アプリ専用)',
  },
  {
    img_url: '/images/wev/service/wev_app_item_3.png',
    text: 'NFC、QR認証',
  },
  {
    img_url: '/images/wev/service/wev_app_item_4.png',
    text: 'メンバーシップローミング企業',
  },
]
export const APP_SECTION_02_DATA_EN = [
  {
    img_url: '/images/wev/service/wev_membership_app_item_1.png',
    text: 'Physical Membership Card',
  },
  {
    img_url: '/images/wev/service/wev_membership_app_item_2.png',
    text: 'Mobile Membership Card\n(APP Only)',
  },
  {
    img_url: '/images/wev/service/wev_app_item_3.png',
    text: 'NFC, QR Authentication',
  },
  {
    img_url: '/images/wev/service/wev_app_item_4.png',
    text: 'Roaming Partners',
  },
]

export const STATION_SIDO_CODE_KR = [
  {
    text: '지역 전체',
    value: null,
    id: 'SIDO_null',
  },
  {
    text: '서울특별시',
    value: 11,
    id: 'SIDO_11',
  },
  {
    text: '부산광역시',
    value: 26,
    id: 'SIDO_21',
  },
  {
    text: '대구광역시',
    value: 27,
    id: 'SIDO_22',
  },
  {
    text: '인천광역시',
    value: 28,
    id: 'SIDO_23',
  },
  {
    text: '광주광역시',
    value: 29,
    id: 'SIDO_24',
  },
  {
    text: '대전광역시',
    value: 30,
    id: 'SIDO_25',
  },
  {
    text: '울산광역시',
    value: 31,
    id: 'SIDO_26',
  },
  {
    text: '세종특별자치시',
    value: 36,
    id: 'SIDO_29',
  },
  {
    text: '경기도',
    value: 41,
    id: 'SIDO_31',
  },
  {
    text: '강원특별자치도',
    value: 51,
    id: 'SIDO_32',
  },
  {
    text: '충청북도',
    value: 43,
    id: 'SIDO_33',
  },
  {
    text: '충청남도',
    value: 44,
    id: 'SIDO_34',
  },
  {
    text: '전북특별자치도',
    value: 52,
    id: 'SIDO_35',
  },
  {
    text: '전라남도',
    value: 46,
    id: 'SIDO_36',
  },
  {
    text: '경상북도',
    value: 47,
    id: 'SIDO_37',
  },
  {
    text: '경상남도',
    value: 48,
    id: 'SIDO_38',
  },
  {
    text: '제주특별자치도',
    value: 50,
    id: 'SIDO_39',
  },
]
export const STATION_SIDO_CODE_EN = [
  {
    text: 'Select Region',
    value: null,
    id: 'SIDO_null',
  },
  {
    text: 'Seoul Metropolitan City',
    value: 11,
    id: 'SIDO_11',
  },
  {
    text: 'Busan Metropolitan City',
    value: 26,
    id: 'SIDO_21',
  },
  {
    text: 'Daegu Metropolitan City',
    value: 27,
    id: 'SIDO_22',
  },
  {
    text: 'Incheon Metropolitan City',
    value: 28,
    id: 'SIDO_23',
  },
  {
    text: 'Gwangju Metropolitan City',
    value: 29,
    id: 'SIDO_24',
  },
  {
    text: 'Daejeon Metropolitan City',
    value: 30,
    id: 'SIDO_25',
  },
  {
    text: 'Ulsan Metropolitan City',
    value: 31,
    id: 'SIDO_26',
  },
  {
    text: 'Sejong Special Self-Governing City',
    value: 36,
    id: 'SIDO_29',
  },
  {
    text: 'Gyeonggi Province',
    value: 41,
    id: 'SIDO_31',
  },
  {
    text: 'Gangwon Special Self-Governing Province',
    value: 51,
    id: 'SIDO_32',
  },
  {
    text: 'Chungcheongbuk Province',
    value: 43,
    id: 'SIDO_33',
  },
  {
    text: 'Chungcheongnam Province',
    value: 44,
    id: 'SIDO_34',
  },
  {
    text: 'Jeonbuk Special Self-Governing Province',
    value: 52,
    id: 'SIDO_35',
  },
  {
    text: 'Jeollanam Province',
    value: 46,
    id: 'SIDO_36',
  },
  {
    text: 'Gyeongsangbuk Province',
    value: 47,
    id: 'SIDO_37',
  },
  {
    text: 'Gyeongsangnam Province',
    value: 48,
    id: 'SIDO_38',
  },
  {
    text: 'Jeju Special Self-Governing Province',
    value: 50,
    id: 'SIDO_39',
  },
]
export const STATION_SIDO_CODE_JP = [
  {
    text: '地域を選択',
    value: null,
    id: 'SIDO_null',
  },
  {
    text: 'ソウル特別市',
    value: 11,
    id: 'SIDO_11',
  },
  {
    text: '釜山広域市',
    value: 26,
    id: 'SIDO_21',
  },
  {
    text: '大邱広域市',
    value: 27,
    id: 'SIDO_22',
  },
  {
    text: '仁川広域市',
    value: 28,
    id: 'SIDO_23',
  },
  {
    text: '光州広域市',
    value: 29,
    id: 'SIDO_24',
  },
  {
    text: '大田広域市',
    value: 30,
    id: 'SIDO_25',
  },
  {
    text: '蔚山広域市',
    value: 31,
    id: 'SIDO_26',
  },
  {
    text: '世宗特別自治市',
    value: 36,
    id: 'SIDO_29',
  },
  {
    text: '京畿道',
    value: 41,
    id: 'SIDO_31',
  },
  {
    text: '江原特別自治道',
    value: 51,
    id: 'SIDO_32',
  },
  {
    text: '忠清北道',
    value: 43,
    id: 'SIDO_33',
  },
  {
    text: '忠清南道',
    value: 44,
    id: 'SIDO_34',
  },
  {
    text: '全北特別自治道',
    value: 52,
    id: 'SIDO_35',
  },
  {
    text: '全羅南道',
    value: 46,
    id: 'SIDO_36',
  },
  {
    text: '慶尚北道',
    value: 47,
    id: 'SIDO_37',
  },
  {
    text: '慶尚南道',
    value: 48,
    id: 'SIDO_38',
  },
  {
    text: '済州特別自治道',
    value: 50,
    id: 'SIDO_39',
  },
]

export const CHARGE_TYPE_CODE_KR = [
  {
    text: '종류 전체',
    value: null,
    id: 'CHARGER_TYPE_null',
  },
  {
    text: 'AC 완속',
    value: 'ACType1J1772',
    id: 'CHARGER_TYPE_ACType1J1772',
  },
  {
    text: 'DC 콤보 타입1',
    value: 'DCCCSType1',
    id: 'CHARGER_TYPE_DCCCSType1',
  },
]

export const STATION_SPEED_CODE_KR = [
  {
    text: '충전 속도 전체',
    value: null,
    id: 'CHARGER_SPEED_null',
  },
  {
    text: '7kW',
    value: 7,
    id: 'CHARGER_SPEED_7',
  },
  {
    text: '30kW',
    value: 30,
    id: 'CHARGER_SPEED_30',
  },
  {
    text: '50kW',
    value: 50,
    id: 'CHARGER_SPEED_50',
  },
  {
    text: '100kW',
    value: 100,
    id: 'CHARGER_SPEED_100',
  },
  {
    text: '200kW',
    value: 200,
    id: 'CHARGER_SPEED_200',
  },
]

export const CHARGE_TYPE_CODE_EN = [
  {
    text: 'Select Type',
    value: null,
    id: 'CHARGER_TYPE_null',
  },
  {
    text: 'AC Slow',
    value: 'ACType1J1772',
    id: 'CHARGER_TYPE_ACType1J1772',
  },
  {
    text: 'DC Combo Type 1',
    value: 'DCCCSType1',
    id: 'CHARGER_TYPE_DCCCSType1',
  },
]

export const STATION_SPEED_CODE_EN = [
  {
    text: 'Select Charging Speed',
    value: null,
    id: 'CHARGER_SPEED_null',
  },
  {
    text: '7kW',
    value: 7,
    id: 'CHARGER_SPEED_7',
  },
  {
    text: '30kW',
    value: 30,
    id: 'CHARGER_SPEED_30',
  },
  {
    text: '50kW',
    value: 50,
    id: 'CHARGER_SPEED_50',
  },
  {
    text: '100kW',
    value: 100,
    id: 'CHARGER_SPEED_100',
  },
  {
    text: '200kW',
    value: 200,
    id: 'CHARGER_SPEED_200',
  },
]

export const CHARGE_TYPE_CODE_JP = [
  {
    text: '種類を選択',
    value: null,
    id: 'CHARGER_TYPE_null',
  },
  {
    text: 'AC普通充電',
    value: 'ACType1J1772',
    id: 'CHARGER_TYPE_ACType1J1772',
  },
  {
    text: 'DCコンボタイプ1',
    value: 'DCCCSType1',
    id: 'CHARGER_TYPE_DCCCSType1',
  },
]

export const STATION_SPEED_CODE_JP = [
  {
    text: '充電速度を選択',
    value: null,
    id: 'CHARGER_SPEED_null',
  },
  {
    text: '7kW',
    value: 7,
    id: 'CHARGER_SPEED_7',
  },
  {
    text: '30kW',
    value: 30,
    id: 'CHARGER_SPEED_30',
  },
  {
    text: '50kW',
    value: 50,
    id: 'CHARGER_SPEED_50',
  },
  {
    text: '100kW',
    value: 100,
    id: 'CHARGER_SPEED_100',
  },
  {
    text: '200kW',
    value: 200,
    id: 'CHARGER_SPEED_200',
  },
]
